document.addEventListener('DOMContentLoaded', () => {

    const form = document.querySelector('.js-contact-form');

    if (!form) {
        return;
    }

    form.addEventListener('submit', (e) => {

        e.preventDefault();

        const nombre =
            document.getElementById('nombre').value.trim();

        const telefono =
            document.getElementById('telefono').value.trim();

        const edad =
            document.getElementById('edad').value.trim();

        const consultaTipo =
            document.getElementById('consulta_tipo').value;

        const consulta =
            document.getElementById('consulta').value.trim();

        const mensaje =
            `*NUEVA CONSULTA - NOVO CIRUGÍA*\n\n` +
            `*Nombre:* ${nombre}\n` +
            `*Teléfono:* ${telefono}\n` +
            `*Edad:* ${edad}\n` +
            `*Consulta:* ${consultaTipo}\n\n` +
            `*Descripción:*\n${consulta}`;

        const whatsappUrl =
            `https://wa.me/51994547626?text=${encodeURIComponent(mensaje)}`;

        window.open(
            whatsappUrl,
            '_blank'
        );

    });

});